// src/components/ForgotPassword.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import '../styles/Auth.css';
import loginBg from '../assets/login1.jpg';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');
    try {
      const response = await authAPI.forgotPassword(email);
      setMessage(response.data.message);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="auth-container"
      style={{ backgroundImage: `url(${loginBg})` }}
    >
      <div className="auth-left">
        <h1 className="auth-hero-title">
          Forgot your<br />password?
        </h1>
        <p className="auth-hero-text">
          No worries — we'll send you a reset link.
        </p>
      </div>

      <div className="auth-card">
        <h2 className="auth-title">Reset Password</h2>

        {message && (
          <div className="error-message" style={{ background: '#d4edda', color: '#155724', borderColor: '#c3e6cb' }}>
            {message}
          </div>
        )}
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading || !!message}
              placeholder="example@mail.com"
            />
          </div>

          <button
            type="submit"
            className="auth-button"
            disabled={loading || !!message}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <p className="auth-link">
          Remembered it? <Link to="/login">Back to Login</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;